import http from '@/utils/httpRequest'

export default {
  getMenuNav: params => {
    return http({
      url: http.adornUrl('/sys/menu/nav'),
      method: 'get',
      params: http.adornParams()
    })
  },
  getMenus: params => {
    return http({
      url: http.adornUrl('/sys/menus'),
      method: 'get',
      params: http.adornParams()
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/sys-menu.js